<template>
  <div v-clickOutside="closeNotification" class="flex relative">
    <!-- notification button -->
    <i class="icon-notifications-off mx-8 cursor-pointer text-21 transition-all duration-300"
       :class="[isOpenNotification || mutedFor ? 'text-error opacity-70' : isDarkMode ?
         'text-app-color opacity-50 hover:opacity-100' : 'text-dark-500 opacity-50 hover:opacity-100']"
       @click.stop="openNotification"
       @mouseenter="showTooltip = true"
       @mouseleave="showTooltip = false"
    />
    <div
      v-show="(isMutedForever || mutedFor) && showTooltip"
      class="whitespace-no-wrap absolute z-10 shadow text-main-color py-5 px-7
             right-0 font-Inter rounded-4 bottom-25 text-10 font-medium"
      :class="isDarkMode ? 'bg-white text-backdrop' : 'bg-backdrop text-white'"
    >
      <span v-if="isMutedForever">Notifications muted forever</span>
      <span v-else>Notifications muted until {{ mutedFor }}</span>
    </div>
    <div
      v-show="isOpenNotification"
      class="absolute max-h-180 min-w-max w-150 cursor-default overflow-y-hidden
                        right-0 top-25 flex flex-col py-8 text-app-color z-10 rounded-4 shadow-dropdown mt-8"
      :class="isDarkMode ? 'bg-sidebar' : 'bg-white'"
    >
      <p class="font-medium text-13 mb-5 px-12 ">{{ title }}</p>
      <div class="px-14">
        <p class="mb-4 text-13 cursor-pointer" @click="setNotification(1)">For 1 hour</p>
        <p class="mb-4 text-13 cursor-pointer" @click="setNotification(4)">For 4 hours</p>
        <p class="mb-4 text-13 cursor-pointer" @click="setNotification(24)">For 24 hours</p>
        <p class="mb-4 text-13 cursor-pointer" @click="setNotification('forever')">Forever</p>
      </div>
      <div v-show="mutedFor">
        <div class="border-b" :class="isDarkMode ? 'opacity-50 border-dark-500' : 'border-grey-400'" />
        <p class="mt-6 text-13 flex items-center justify-center cursor-pointer" @click="setNotification(null)">
          <i class="icon-notifications-on mx-4 text-18 transition-all duration-300 text-green-700" />Unmute
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { computed, defineComponent, ref } from 'vue'
import { useStore } from 'vuex'
import { parseDate } from '@/plugins/filters'

export default defineComponent({
  props: {
    title: { type: String },
    mutedAt: (String || null)
  },

  emits: ['closeNotification', 'setNotification'],

  setup (props, { emit }) {
    const { getters } = useStore()

    const mutedFor = computed(() => {
      if (props.mutedAt) {
        return parseDate(props.mutedAt, 'notification')
      } else {
        return false
      }
    })

    const isMutedForever = computed(() => {
      return (new Date(props.mutedAt) - new Date()) > 24 * 60 * 60 * 1000
    })

    const showTooltip = ref(false)
    const isOpenNotification = ref(false)

    const isDarkMode = computed(() => getters.isDarkMode)

    function setNotification (value) {
      if (value) {
        const hours = value === 'forever' ? 100000 : value

        const date = new Date().getTime() + hours * 60 * 60 * 1000

        emit('setNotification', new Date(date))
      } else {
        emit('setNotification', null)
      }

      closeNotification()
    }

    function openNotification () {
      isOpenNotification.value = !isOpenNotification.value
    }

    function closeNotification () {
      isOpenNotification.value = false
    }

    return {
      mutedFor,
      // ref
      showTooltip,
      isOpenNotification,
      // computed
      isDarkMode,
      isMutedForever,
      // function
      openNotification,
      closeNotification,
      setNotification
    }
  }
})
</script>
